import script from "./LenguageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LenguageSelector.vue?vue&type=script&setup=true&lang=js"

import "./LenguageSelector.vue?vue&type=style&index=0&id=6855b2c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6855b2c8"]])

export default __exports__